/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];


